/*
main.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

/* eslint-disable @typescript-eslint/no-explicit-any */
import { createRoot } from 'react-dom/client'
import { lazy, Suspense } from 'react';

import './polyfills.ts'
// Keep legacy polyfills usage-driven to avoid bundling unsupported polyfills.
import 'regenerator-runtime/runtime'
import 'text-encoding'

// 3rd-party UI behavior libraries (evaluate if all are still needed)
// import 'xidsjs/js/src/vendor/xwuikit/collapse'
// import 'xidsjs/js/src/vendor/xwuikit/jquery.menu-aim'

// EIP/XIDS components — consider importing only what’s used
import 'xidsjs/js/src/xrx-checkbox'
// import 'xidsjs/js/src/xrx-dropdown'
// import 'xidsjs/js/src/xrx-navbar'
// import 'xidsjs/js/src/xrx-modal'
// import 'xidsjs/js/src/xrx-radio'
// import 'xidsjs/js/src/xrx-switch'
// import 'xidsjs/js/src/xrx-input'
// import 'xidsjs/js/src/xrx-tab'

// ⚛️ React & App
import App from './app.tsx'
import i18n from './i18n.ts'
import { I18nextProvider } from 'react-i18next'

import BaseProvider from './providers/baseProvider.tsx'

//Lazy-load heavier or less-used providers
const ToastProvider = lazy(() => import('./providers/toastProvider.tsx'))
const InfoModalProvider = lazy(() => import('./providers/infoModalProvider.tsx'))
const JobSettingsProvider = lazy(() => import('./providers/jobSettingsProvider.tsx'))
const SummaryProvider = lazy(() => import('./providers/redactionProvider.tsx'))

const root = createRoot(document.getElementById('root')!)
root.render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={null}>
      <InfoModalProvider>
        <ToastProvider>
          <BaseProvider>
            <JobSettingsProvider>
              <SummaryProvider>
                <App />
              </SummaryProvider>
            </JobSettingsProvider>
          </BaseProvider>
        </ToastProvider>
      </InfoModalProvider>
    </Suspense>
  </I18nextProvider>
)
